import { Component, Input, OnInit, Renderer2, ViewChild } from '@angular/core';
import { HubConnection } from '@microsoft/signalr';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { IconHover } from '../../../enum/common-enum';
import { InputDatepickerRendererComponent } from '../../ag-grid/input-datepicker-renderer/input-datepicker-renderer.component';
import { CommonService } from '../../../services/common.service';

@Component({
  selector: 'app-closing',
  templateUrl: './closing.component.html',
  styleUrls: ['./closing.component.scss']
})
export class ClosingComponent extends CommonService  implements OnInit {
  @Input() data: any;
  message = '';
  currentHoverEffect = IconHover.Pink;
  messages: string[] = [];
  @Input() isjobworkorderlist: boolean;
  private hubConnection: HubConnection | undefined;
  @ViewChild('closingDateComp') closingDateComponent: InputDatepickerRendererComponent;

  constructor(
    public activeModal: NgbActiveModal,
    public toaster: ToastrService,
     public renderer         : Renderer2,
  ) {super(renderer);}

  ngOnInit(): void {
    this.data;
  }

  calculateItem() {
    if (this.data?.model?.lossWt && this.data?.model?.purityPer)
    this.data.model.purityWt = Number(this.data?.model?.lossWt ?? 0) *  Number(this.data?.model?.purityPer ?? 0);
  }

  calculateGoldLossValue() {
    if(this.data?.model?.purityWt && this.data?.model?.goldRate)
      this.data.model.goldLossValue = Number(this.data?.model?.purityWt ?? 0) * Number(this.data?.model?.goldRate ?? 0);
  }
  
  calculateAvgLossPerKg() {
    const lossWt = Number(this.data?.model?.lossWt ?? 0);
    const workDone = Number(this.data?.model?.workDone ?? 0);
    this.data.model.avgLoss = workDone > 0 ? (lossWt / workDone) : 0;
  }

  onSave() {
    const currentTime = this.closingDateComponent.getCurrentTime();
    this.data.model.closingDate = `${this.data?.model?.closingDate?.split('T')[0]}T${currentTime}`;
    this.activeModal.close({ isSuccess: true, data: this.data });
  }

  dismiss() {
    this.activeModal.close({ isSuccess: false })
  }

  ngOnDestroy(): void {
  }

  selectedDates(event?: any) {
    this.data.model.closingDate = event;
  }
}
